import React, { useEffect, useState } from 'react';
import api from '../../utils/api';

const STATUS_COLORS = {
  succeeded: 'bg-green-100 text-green-700',
  pending: 'bg-yellow-100 text-yellow-700',
  failed: 'bg-red-100 text-red-700',
  refunded: 'bg-gray-100 text-gray-700'
};

const PaymentsPage = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({ total: 0, fees: 0, net: 0 });

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const { data } = await api.get('/payments');
        setPayments(data.payments);
        setStats(data.stats);
      } catch (err) {
        console.error('Failed to load payments');
      } finally {
        setLoading(false);
      }
    };
    fetchPayments();
  }, []);

  if (loading) return <div className="text-gray-500">Loading payments...</div>;

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Payments</h1>

      {/* Stats */}
      <div className="mb-6">
        <div className="bg-white p-5 rounded-xl border border-gray-100 shadow-sm inline-block">
          <div className="text-2xl font-bold text-gray-900">${stats.total?.toFixed(2) || '0.00'}</div>
          <div className="text-sm text-gray-500 mt-1">Total Revenue</div>
        </div>
      </div>

      {/* Payment list */}
      {payments.length === 0 ? (
        <div className="bg-white p-8 rounded-xl border border-gray-100 shadow-sm text-center text-gray-500">
          No payments yet. Payments will appear here once students enroll.
        </div>
      ) : (
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden overflow-x-auto">
          <table className="w-full text-sm min-w-[600px]">
            <thead className="bg-gray-50 border-b border-gray-100">
              <tr>
                <th className="text-left px-4 py-3 font-medium text-gray-600">Student</th>
                <th className="text-left px-4 py-3 font-medium text-gray-600">Course</th>
                <th className="text-left px-4 py-3 font-medium text-gray-600">Type</th>
                <th className="text-right px-4 py-3 font-medium text-gray-600">Amount</th>
                <th className="text-center px-4 py-3 font-medium text-gray-600">Status</th>
                <th className="text-right px-4 py-3 font-medium text-gray-600">Date</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {payments.map(p => (
                <tr key={p._id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-gray-900">{p.student?.name || p.student?.email || '—'}</td>
                  <td className="px-4 py-3 text-gray-700">{p.course?.name || '—'}</td>
                  <td className="px-4 py-3 text-gray-500 capitalize">{p.type?.replace('_', ' ')}</td>
                  <td className="px-4 py-3 text-right text-gray-900">${p.amount?.toFixed(2)}</td>
                  <td className="px-4 py-3 text-center">
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${STATUS_COLORS[p.status] || 'bg-gray-100 text-gray-500'}`}>
                      {p.status}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-right text-gray-500">
                    {new Date(p.createdAt).toLocaleDateString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PaymentsPage;
